import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import {
  supraSubscriptionTypeToLabelMap,
  SupraSystemSubscriptionType,
} from '@bb/domain/dist/types';

type UserTypeTagProps = {
  type: SupraSystemSubscriptionType;
};

const subRoleMap: Record<
  SupraSystemSubscriptionType,
  Record<'color' | 'label', string>
> = Object.values(SupraSystemSubscriptionType).reduce(
  (acc, subRole) => ({
    ...acc,
    [subRole]: {
      color: 'blue',
      label: supraSubscriptionTypeToLabelMap[subRole],
    },
  }),
  {} as Record<SupraSystemSubscriptionType, Record<'color' | 'label', string>>,
);

const UserTypeTag: React.FC<UserTypeTagProps> = ({ type }) => {
  if (!type || !subRoleMap[type]) return null;

  const { color, label } = subRoleMap[type];

  return <StyledTag color={color}>{label}</StyledTag>;
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default UserTypeTag;
